module.exports = __webpack_public_path__ + "img/SIRCLO.38efc451.png";